import { pickLocale, type LocalizedString } from '../schema';

interface HeaderProps {
    title: LocalizedString;
    headline: LocalizedString;
    locale: string | undefined;
    fallbackTitle: string;
}

// Never emit a real <h1>: the storefront product page already owns that
// landmark, and on standalone preview pages the embedding admin page
// supplies its own. Bundle uses a div with role="heading" aria-level="2"
// so screen readers still see a heading without SEO contamination.
export function Header({ title, headline, locale, fallbackTitle }: HeaderProps) {
    const resolvedTitle = pickLocale(title, locale) ?? fallbackTitle;
    const resolvedHeadline = pickLocale(headline, locale);
    return (
        <header className="cfg-header">
            <div role="heading" aria-level={2} className="cfg-header__title">
                {resolvedTitle}
            </div>
            {resolvedHeadline && <p className="cfg-header__headline">{resolvedHeadline}</p>}
        </header>
    );
}
